import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GapPlanBenefit} from '../../models/gap-plan-benefit';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  private _planBenefitsUrl: string = '/wcm/discoverycoza/tools/gap-quoting-on-dna-plan-benefits.json';

  constructor(private httpClient: HttpClient) { }

  public getPlanBenefits(): Observable<Array<GapPlanBenefit>> {
    return this.httpClient.get<Array<GapPlanBenefit>>(this._planBenefitsUrl, {
      headers: new HttpHeaders(),
      responseType: 'json'
    });
  }

  public scrollToTop(): void {
    window.scrollTo({behavior: 'smooth', top: 0});
    window.parent.scrollTo({behavior: 'smooth', top: 0});
  }
}
